import { User } from 'oidc-client'
import { AuthServiceLocator } from './AuthServiceLocator'
import { User as UserIntf } from '@/interfaces/IUser'

/**
 * AuthService Facade - maintains the same static API for backward compatibility
 * while delegating to the appropriate implementation based on feature flags
 */
export class AuthService {
	static async init(): Promise<void> {
		const service = await AuthServiceLocator.getAuthService()
		await service.init()
	}

	static async getUser(): Promise<User | null> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.getUser()
	}

	static async login(): Promise<void> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.login()
	}

	static async logout(): Promise<void> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.logout()
	}

	static async setUserStore(user: User | null = null): Promise<User | null> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.setUserStore(user)
	}

	static async authorizeByEncryptedId(id: string): Promise<string> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.authorizeByEncryptedId(id)
	}

	static async GetUserByEncryptedId(id: string): Promise<User> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.GetUserByEncryptedId(id)
	}

	static async getUserByToken(token: string): Promise<User> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.getUserByToken(token)
	}

	static async refreshToken(): Promise<any> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.refreshToken()
	}

	static async setPassword(cpf: string): Promise<any> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.setPassword(cpf)
	}

	static async initializeUserContext(): Promise<void> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.initializeUserContext()
	}

	static async setActiveUserAccount(user: UserIntf.IUserAccount): Promise<void> {
		const service = await AuthServiceLocator.getAuthService()
		return await service.setActiveUserAccount(user)
	}
}
